module.exports = __webpack_public_path__ + "img/horizontal_4_3_pp3_5012.9c103aa1.png";